module.exports = __webpack_public_path__ + "static/media/delete-x-white.95ed022a.svg";